import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import {featureInterface} from "../../../../interfaces/featureInterface";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import IconButton from "@mui/material/IconButton";

import {ROUTES} from "../../../../routes";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {shopContextAction, useShopContext} from "./shopNavItemsContext";
import {updateCanvasCount} from "../../../../actions/actionFunctions";

const ShopCategoryBackNextButtons = (props) => {

  const {history, intl} = props;

  const {shopContextState, shopContextDispatch} = useShopContext();
  const {shopLastActiveFeature} = shopContextState;

  if (!shopLastActiveFeature) {
    return null
  }

  const nextButtonClick = () => {
    history.push(`${ROUTES.shop}/${shopLastActiveFeature.partId}/`);
    const featureLabel = Analytics.getSkuForAnalytics(shopLastActiveFeature);
    const analyticsLabel = PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesNext + featureLabel;
    Analytics.sendClickEvent(analyticsLabel);

    const name = shopLastActiveFeature.dbFeature.sku || shopLastActiveFeature.dbFeature.sharedFeatureName;

    shopContextDispatch(shopContextAction({shopActiveFeature: name}))

    history.push(`${ROUTES.shop}/${shopLastActiveFeature.partId}/${name}`);
    updateCanvasCount();
  }

  return (
    <div className="shop-navigate shop-navigate--category">
      {/*<IconButton aria-label={intl.formatMessage({id: "iconButton.back"})}*/}
      {/*            className="look-icon look-icon--small1 look-icon--gray shop-feature__navigate-button"*/}
      {/*            onClick={backButtonClick}>*/}
      {/*  <NavigateBeforeIcon/>*/}
      {/*</IconButton>*/}
      <IconButton aria-label={intl.formatMessage({id: "iconButton.next"})}
                  className="look-icon look-icon--small1 look-icon--gray shop-feature__navigate-button"
                  onClick={nextButtonClick}>
        <NavigateNextIcon/>
      </IconButton>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {shopPageLeaved} = store.shopState;
  return {
    shopPageLeaved
  };
};

const mapDispatchToProps = {
  updateCanvasCount
};

ShopCategoryBackNextButtons.propTypes = {
  feature: PropTypes.shape(featureInterface)
}

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(ShopCategoryBackNextButtons)
  )
)
